export enum ActivitiesTabPage {
  ActivitiesInProgress = 'ActivitiesInProgress',
  ActivitiesToDo = 'ActivitiesToDo',
  OffPlatformActivities = 'OffPlatformActivities',
}

export interface SearchFormValues {
  text: string;
}
